module.exports = __webpack_public_path__ + "static/media/12 Tuba Region 20 Scales.b967b508.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/band/middleSchool/scales/12 Tuba Region 20 Scales.pdf
// module id = 285
// module chunks = 0